module.exports = __webpack_public_path__ + "img/connect_white.20ede537.png";